import React from 'react';
import { withRouter } from 'react-router-dom';
import Dotdotdot from 'react-dotdotdot';
import { StringUtil } from 'utils/StringUtil';
import { Counter } from 'components/atoms/counter';
import { RouteNames } from 'router';
import { Image } from 'components/atoms/image';
import { HTMLView } from 'components/atoms/htmlView';
// eslint-disable-next-line
import "./styles.scss";

const VisionPhilosophyCardMobile = props => {
  const { data, dataLength, count } = props;

  let description = StringUtil.sliceHtml(data && data.description);
  const onPageChange = props.location.pathname !== RouteNames.about;
  const width = dataLength === 1 ? '100vw' : '90vw';
  const marginLeft = dataLength === 1 ? '80%' : '23%';
  const imageMargin = dataLength === 1 ? '-2.5%' : {};

  return (
    <div className={'vision-card-mobile'} style={{ marginLeft: imageMargin }}>
      <div className={'vision-image'} style={{ width: width }}>
        <Image src={data && data.image} alt={'media'} />
      </div>
      <div className={'vision-section-content'}>
        <HTMLView
          className={'sub-heading'}
          html={onPageChange ? data.tag_word : data.page_title}
          tagName={'div'}
        />
        <Dotdotdot clamp={4} tagName={'p'}>
          <div className={'section-description'}>{description}</div>
        </Dotdotdot>
      </div>
      {onPageChange && (
        <Counter
          count={count + 1}
          type={'medium'}
          className={'image-counter'}
          style={{ marginLeft: marginLeft }}
        />
      )}
    </div>
  );
};

export default withRouter(VisionPhilosophyCardMobile);
